var _desc, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgVeganism = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Food-Allegic-Vegan-Meal-Symbol--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Food Allegic Vegan Meal Symbol Streamline Icon: https://streamlinehq.com")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.08 0.49a0.5 0.5 0 0 0 -0.5 -0.46c-0.3 0 -7.51 0 -10 3.08a6.87 6.87 0 0 0 -1 8 20.45 20.45 0 0 1 4.7 -6.4 1 1 0 0 1 1.41 0.09 1.08 1.08 0 0 1 0.22 0.44 1 1 0 0 0 -0.55 0.24C13.26 9 11.09 14.85 10 18.81c-0.13 -0.82 -0.29 -1.72 -0.49 -2.65C8.38 10.5 6.05 3.29 1.6 1.28a0.51 0.51 0 0 0 -0.52 0.06 0.49 0.49 0 0 0 -0.18 0.48 70.81 70.81 0 0 0 8.27 21.06 1 1 0 0 0 0.53 0.86 0.5 0.5 0 0 0 0.42 0.23 0.4 0.4 0 0 0 0.15 0 0.38 0.38 0 0 0 0.21 -0.13 1 1 0 0 0 0.68 -0.79 38.19 38.19 0 0 1 3.11 -10 5.23 5.23 0 0 0 1 0.09c2.11 0 4.24 -1.26 5.82 -3.59C23.49 5.92 23.1 0.71 23.08 0.49Z",
    fill: "currentColor",
    strokeWidth: 1
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgVeganism);
export default ForwardRef;